import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import BetaSignupForm from './BetaSignupForm';
import { setPageMeta } from './pageMeta';
import { HOME_DESCRIPTION, HOME_TITLE } from './seoMeta';
import './Marketing.css';

function HomePage() {
  useEffect(() => {
    setPageMeta({
      title: HOME_TITLE,
      description: HOME_DESCRIPTION,
      path: '/',
      ogType: 'website',
      schema: 'WebPage',
    });
  }, []);

  return (
    <>
      <section className="marketing-hero">
        <div className="marketing-hero-inner">
          <h1>AI-empowered workspace for human-written content</h1>
          <p className="marketing-hero-lead">
          Racontera helps writers discover content opportunities, organize research, build source-backed outlines, and develop publish-ready articles—all while keeping authorship and editorial judgment in human hands..
          </p>
          <div className="marketing-hero-actions">
            <a href="#beta" className="marketing-btn marketing-btn-primary">
              Request beta access
            </a>
            <Link to="/blog" className="marketing-btn marketing-btn-secondary">
              Read the blog
            </Link>
          </div>
        </div>
      </section>

      <section className="marketing-section">
        <h2 className="marketing-section-title">Built for professional content workflows</h2>
        <p className="marketing-section-sub">
          A focused workflow from research reports to approved drafts and publishing.
        </p>
        <div className="marketing-features">
          <div className="marketing-feature">
            <h3>Research</h3>
            <p>
              Run focused research with profiles and reports. Prioritize topics by SEO
              and lead value before you write.
            </p>
          </div>
          <div className="marketing-feature">
            <h3>Write</h3>
            <p>
              Move approved ideas into draft workspaces with format-aware briefs for
              blogs, case studies, white papers, and more.
            </p>
          </div>
          <div className="marketing-feature">
            <h3>Publish</h3>
            <p>
              Push approved drafts to your publishing queue and WordPress as drafts,
              then mark them live when you are ready.
            </p>
          </div>
        </div>
      </section>

      <section className="marketing-compare" aria-labelledby="compare-heading">
        <div className="marketing-compare-inner">
          <h2 id="compare-heading" className="marketing-compare-title">
            How Racontera is different
          </h2>
          <div className="marketing-compare-table" role="table">
            <div className="marketing-compare-row marketing-compare-header" role="row">
              <div className="marketing-compare-cell" role="columnheader">
                Typical AI Writer
              </div>
              <div className="marketing-compare-cell marketing-compare-cell-highlight" role="columnheader">
                Racontera
              </div>
            </div>
            <div className="marketing-compare-row" role="row">
              <div className="marketing-compare-cell" role="cell">
                Generates articles for you
              </div>
              <div className="marketing-compare-cell marketing-compare-cell-highlight" role="cell">
                Supports human-written content
              </div>
            </div>
            <div className="marketing-compare-row" role="row">
              <div className="marketing-compare-cell" role="cell">
                Focuses on drafting
              </div>
              <div className="marketing-compare-cell marketing-compare-cell-highlight" role="cell">
                Focuses on research + organization + drafting
              </div>
            </div>
            <div className="marketing-compare-row" role="row">
              <div className="marketing-compare-cell" role="cell">
                Optimized for volume
              </div>
              <div className="marketing-compare-cell marketing-compare-cell-highlight" role="cell">
                Optimized for quality and expertise
              </div>
            </div>
            <div className="marketing-compare-row marketing-compare-row-last" role="row">
              <div className="marketing-compare-cell" role="cell">
                Replaces the process
              </div>
              <div className="marketing-compare-cell marketing-compare-cell-highlight" role="cell">
                Supports the process
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="marketing-beta" id="beta">
        <div className="marketing-beta-inner">
          <h2>Join the beta</h2>
          <p>
            We are onboarding teams in batches. Leave your details and we will reach
            out when a spot opens.
          </p>
          <BetaSignupForm />
        </div>
      </section>
    </>
  );
}

export default HomePage;
